<template>
  <form v-if="channel.name" @submit.prevent="promiseDeleteChannel = handleDelete()">
    <b-modal v-model="showDeleteModal"
             title="Delete Channel"
             @hide="hideModal">
      <p>
        This action <b>CANNOT</b> be undone. This will permanently delete the <b>{{channel.name}}</b> channel, webhook
        and contacts.
      </p>
      <div class="form-group">
        <label for="channel-name-input">Please type in the channel name to confirm.</label>
        <input type="text" v-model.trim="name" class="form-control" id="channel-name-input"/>
      </div>

      <template slot="modal-footer">
        <button type="button" class="btn btn-secondary" @click="hideModal">Cancel</button>
        <!-- "Ladda button" breaks disabling button -->
        <button v-show="deleteAllowed" type="submit" class="mr-0 btn btn-danger"
                v-busy-button="promiseDeleteChannel">Delete
        </button>
        <button v-show="!deleteAllowed" disabled type="button" class="btn btn-danger">Delete</button>
      </template>
    </b-modal>
  </form>
</template>

<script>
  import channelService from '@/services/amio-api/channel.service'
  import notificationService from '@/services/notification/notification.service'

  export default {
    store: {
      showDeleteModal: 'administration.channelDetail.showDeleteModal'
    },

    props: {
      channel: {
        type: Object,
        required: true
      }
    },

    data() {
      return {
        name: '',
        promiseDeleteChannel: null
      }
    },

    computed: {
      deleteAllowed() {
        return this.isDeleteAllowed()
      }
    },

    methods: {
      hideModal() {
        this.clearData()
        this.showDeleteModal = false
      },

      clearData() {
        this.name = ''
        this.promiseDeleteChannel = null
      },

      handleDelete() {
        if (!this.isDeleteAllowed()) {
          return
        }
        return channelService.delete(this.channel.id)
          .then(() => {
            this.$emit('channelDeleted', this.channel)
            notificationService.success('Channel was successfully deleted')
          })
          .then(this.hideModal)
          .catch(this.clearData)
      },

      isDeleteAllowed() {
        return !this.channel.name || this.name.trim() === this.channel.name.trim()
      }
    }
  }
</script>
